import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";

export default class LanguageSelectorService {

  static getLanguages() {
    return HttpUtil.get(
      API_ROUTES.LANGUAGE_SELECT.GET_COMP_LANGUAGES
        // .replace('<period>', period)
    );
  }

}
